import React from "react";

export default function ContentBlockList({ blocks = [] }) {
  if (!blocks.length) return null;

  // Filter out sign_off blocks — those are coordinator-facing, not caregiver-facing
  const visible = blocks.filter(b => !b.tags?.includes("sign_off"));
  if (!visible.length) return null;

  return (
    <div style={styles.list}>
      {visible.map((block) => (
        <div key={block.id} style={styles.block}>
          {block.title && <h3 style={styles.title}>{block.title}</h3>}
          {block.body && <p style={styles.body}>{block.body}</p>}
          {block.external_url && (
            <a href={block.external_url} style={styles.link}
               target="_blank" rel="noopener noreferrer">
              {block.external_url}
            </a>
          )}
        </div>
      ))}
    </div>
  );
}

const styles = {
  list: { display: "flex", flexDirection: "column", gap: "var(--space-5)" },
  block: {
    background: "var(--color-surface)",
    border: "1px solid var(--color-border)",
    borderRadius: "var(--radius-lg)",
    padding: "var(--space-6)",
  },
  title: {
    fontSize: "var(--text-base)",
    fontWeight: "var(--weight-semibold)",
    color: "var(--color-text-primary)",
    marginBottom: "var(--space-2)",
  },
  body: {
    fontSize: "var(--text-base)",
    color: "var(--color-text-secondary)",
    lineHeight: "var(--leading-loose)",
  },
  link: {
    fontSize: "var(--text-sm)",
    color: "var(--color-accent)",
  },
};
